export enum VendorsTypes {
  Maintenance = "Maintenance",
  Concierge = "Concierge"
}